export function canWritePartner(raw = '[]') {
  try { const roles = JSON.parse(raw || '[]'); return Array.isArray(roles) && roles.some(role => String(role).toUpperCase() === 'ROLE_PARTNER_WRITE'); } catch { return false; }
}
export function partnerErrors(values, t) {
  const errors = {};
  if (!String(values.name || '').trim()) errors.name = t('partnerNameRequired');
  if (values.type === 'ORGANISATION' && !String(values.vat_number || '').trim() && !String(values.email || '').trim()) errors.vat_number = errors.email = t('partnerVatOrEmailRequired');
  return errors;
}
